<template>
  <div class="department">
    <DpplTooltip
      tooltip-placement="left"
      :tooltip-offset="12"
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <p
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          {{ departmentName }}
        </p>
      </template>
      <template #tooltip-content>
        <p class="content">
          {{ departmentName }}
        </p>
      </template>
    </DpplTooltip>
  </div>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

defineProps({
  departmentName: {
    type: String,
    default: '',
  },
});
</script>

<style lang="less" scoped>
.department {
  max-width: 100%;

  :deep(p) {
    font-size: 13px;
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &.content {
      line-height: 150%;
      color: @text-light;
      overflow: visible;
      white-space: normal;
    }
  }
}
</style>
